// extracted by mini-css-extract-plugin
export default {"main":"_037ce9e476 _721f9f1d30","xmark":"c210a9c515","fl_img":"b0f7cab275 _596aadc8ab"};